'use strict';

var commons = require('../../commons');
var getExpressPaymentMethods = commons.getExpressPaymentMethods;
var paymentMethodsIndex = require('../paymentMethods/index');
var Paypal = paymentMethodsIndex.Paypal;
var GooglePay = paymentMethodsIndex.GooglePay;
var AmazonPay = paymentMethodsIndex.AmazonPay;

// Custom: Use our custom ApplePay with Peter Millar customizations
var ApplePay = require('../paymentMethods/applepay/applepay');
var constants = require('../../../constants');
var APPLE_PAY = constants.APPLE_PAY;
var GOOGLE_PAY = constants.GOOGLE_PAY;
var PAYPAL = constants.PAYPAL;
var AMAZON_PAY = constants.AMAZON_PAY;
var PAY_WITH_GOOGLE = constants.PAY_WITH_GOOGLE;

var store = require('../../../store');

function hasEventListener(eventName) {
    // eslint-disable-next-line no-underscore-dangle
    var events = $._data($('body')[0], 'events');
    return events && events[eventName];
}

function getPaymentMethodConfig(adyenPaymentMethods, paymentMethodType) {
    if (adyenPaymentMethods && adyenPaymentMethods.paymentMethods) {
        var paymentMethod = adyenPaymentMethods.paymentMethods.find(function (pm) {
            return paymentMethodType.indexOf(pm.type) > -1;
        });
        return paymentMethod ? paymentMethod.configuration : null;
    }
    return null;
}

function showExpressPayment(container) {
    $('body').addClass('apple-pay-enabled');
    $(container)
        .closest('.cart-express-checkout-section, .express-checkout-section')
        .removeClass('d-none')
        .show()
        .addClass('d-block');
    $(container).closest('#express-container').removeClass('hidden').show();
}

function hideUnavailableApplePay(container, hideSection) {
    $(container).hide();
    $(container).closest('.apple-pay.button').hide();
    var isPayPalVisible = $('.express-checkout-section [data-method="paypal"][data-paypal-mounted="true"]').length > 0;
    if (hideSection && !isPayPalVisible) {
        $(container).closest('#express-container').addClass('hidden').hide();
        $(container).closest('.cart-express-checkout-section, .express-checkout-section').hide().removeClass('d-block');
    }
}

function mountAdditionalApplePay(applePayConfig, applicationInfo, container) {
    var additionalApplePay = new ApplePay(
        applePayConfig,
        applicationInfo,
        false
    );
    additionalApplePay.getComponent().then(function (component) {
        component.isAvailable().then(function () {
            component.mount(container);
        }).catch(function () {
            hideUnavailableApplePay(container, false);
        });
    }).catch(function () {
        hideUnavailableApplePay(container, false);
    });
}

// Custom: Mount to existing containers instead of creating new ones
function renderApplePayButtonListener(e, response) {
    var paymentMethodsResponse = response.paymentMethodsResponse || {};
    var AdyenPaymentMethods = paymentMethodsResponse.AdyenPaymentMethods;
    var applicationInfo = paymentMethodsResponse.applicationInfo;

    var applePayConfig = getPaymentMethodConfig(AdyenPaymentMethods, APPLE_PAY);
    if (!applePayConfig) {
        return;
    }

    // Custom: Find all existing Apple Pay containers
    var containers = document.querySelectorAll('.express-checkout-card [data-method="applepay"]');
    if (!containers.length) {
        return;
    }

    var applePay = new ApplePay(
        applePayConfig,
        applicationInfo,
        false
    );

    applePay.getComponent().then(function (applePayComponent) {
        applePayComponent.isAvailable().then(function () {
            showExpressPayment(containers[0]);
            // Custom: Mount to each existing container
            for (var i = 0; i < containers.length; i++) {
                var container = containers[i];
                if (i === 0) {
                    applePayComponent.mount(container);
                } else {
                    // Create separate instance for additional containers
                    mountAdditionalApplePay(applePayConfig, applicationInfo, container);
                }
            }
        }).catch(function () {
            for (var i = 0; i < containers.length; i++) {
                hideUnavailableApplePay(containers[i], true);
            }
        });
    }).catch(function () {
        for (var i = 0; i < containers.length; i++) {
            hideUnavailableApplePay(containers[i], true);
        }
    });
}

function renderPayPalButtonListener(e, response) {
    var paymentMethodsResponse = response.paymentMethodsResponse || {};
    var AdyenPaymentMethods = paymentMethodsResponse.AdyenPaymentMethods;
    var applicationInfo = paymentMethodsResponse.applicationInfo;

    var paypalConfig = getPaymentMethodConfig(AdyenPaymentMethods, PAYPAL);
    if (!paypalConfig) {
        return;
    }

    // Custom: Find existing PayPal container
    var container = document.querySelector('.express-checkout-section [data-method="paypal"]');
    if (!container) {
        return;
    }

    // Custom: Peter Millar - Only show PayPal Express on checkout page
    if (!document.getElementById('checkout-main')) {
        return;
    }

    var paypal = new Paypal(paypalConfig, applicationInfo);
    paypal.getComponent().then(function (paypalComponent) {
        paypalComponent.mount(container);
        $(container).attr('data-paypal-mounted', 'true');
        $(container)
            .closest('.express-checkout-section')
            .removeClass('d-none')
            .show()
            .addClass('d-block');
        $(container).closest('#express-container').removeClass('hidden').show();
    });
}

function renderAmazonPayButtonListener(e, response) {
    var paymentMethodsResponse = response.paymentMethodsResponse || {};
    var AdyenPaymentMethods = paymentMethodsResponse.AdyenPaymentMethods;
    var applicationInfo = paymentMethodsResponse.applicationInfo;

    var amazonPayConfig = getPaymentMethodConfig(
        AdyenPaymentMethods,
        AMAZON_PAY
    );
    if (!amazonPayConfig) {
        return;
    }

    // Custom: Find existing AmazonPay container
    var container = document.querySelector('[data-method="amazonpay"]');
    if (!container) {
        return;
    }

    var amazonPay = new AmazonPay(
        amazonPayConfig,
        applicationInfo
    );
    amazonPay.getComponent().then(function (amazonPayComponent) {
        amazonPayComponent.mount(container);
    });
}

function renderGooglePayButtonListener(e, response) {
    var paymentMethodsResponse = response.paymentMethodsResponse || {};
    var AdyenPaymentMethods = paymentMethodsResponse.AdyenPaymentMethods;
    var applicationInfo = paymentMethodsResponse.applicationInfo;

    var googlePayConfig = getPaymentMethodConfig(AdyenPaymentMethods, [
        GOOGLE_PAY,
        PAY_WITH_GOOGLE
    ]);
    if (!googlePayConfig) {
        return;
    }

    // Custom: Find existing GooglePay container
    var container = document.querySelector('[data-method="googlepay"]');
    if (!container) {
        return;
    }

    var googlePay = new GooglePay(
        googlePayConfig,
        applicationInfo,
        false
    );
    googlePay.getComponent().then(function (googlePayComponent) {
        googlePayComponent.mount(container);
    });
}

// Custom: Trigger rendering for existing containers
function renderExpressPaymentContainerListener(e, response) {
    var paymentMethodsResponse = response.paymentMethodsResponse;
    var $expressContainer = document.getElementById('express-container');

    if (!$expressContainer) {
        return;
    }

    $('#express-container').spinner().start();

    // Trigger rendering for each payment method that has a container
    var methods = [
        { type: APPLE_PAY, event: 'cart:render' + APPLE_PAY + 'Button' },
        { type: PAYPAL, event: 'cart:render' + PAYPAL + 'Button' }
        // { type: AMAZON_PAY, event: 'cart:render' + AMAZON_PAY + 'Button' },
        // { type: GOOGLE_PAY, event: 'cart:render' + GOOGLE_PAY + 'Button' }
    ];

    methods.forEach(function (method) {
        var container = document.querySelector('[data-method="' + method.type.toLowerCase() + '"]');
        if (container) {
            $('body').trigger(method.event, { paymentMethodsResponse: paymentMethodsResponse });
        }
    });

    $.spinner().stop();

    $('#express-loader-container').hide();
}

function renderPayPalButton() {
    var eventName = 'cart:render' + PAYPAL + 'Button';
    if (!hasEventListener(eventName)) {
        $('body').on(eventName, renderPayPalButtonListener);
    }
}

function renderApplePayButton() {
    var eventName = 'cart:render' + APPLE_PAY + 'Button';
    if (!hasEventListener(eventName)) {
        $('body').on(eventName, renderApplePayButtonListener);
    }
}

function renderAmazonPayButton() {
    var eventName = 'cart:render' + AMAZON_PAY + 'Button';
    if (!hasEventListener(eventName)) {
        $('body').on(eventName, renderAmazonPayButtonListener);
    }
}

function renderGooglePayButton() {
    var eventName = 'cart:render' + GOOGLE_PAY + 'Button';
    if (!hasEventListener(eventName)) {
        $('body').on(eventName, renderGooglePayButtonListener);
    }
}

function renderExpressPaymentContainer() {
    var eventName = 'cart:renderExpressPaymentContainer';
    if (!hasEventListener(eventName)) {
        $('body').on(eventName, renderExpressPaymentContainerListener);
    }
}

function init() {
    // Custom: Check if express payments container exists (cart, minicart, or checkout)
    var expressContainer = document.getElementById('express-container');
    if (!expressContainer) {
        return;
    }

    getExpressPaymentMethods().then(function (paymentMethodsResponse) {
        store.paymentMethodsResponse = paymentMethodsResponse;

        $(document).ready(function () {
            $('body').trigger('cart:renderExpressPaymentContainer', {
                paymentMethodsResponse: paymentMethodsResponse
            });
        });
    }).catch(function (error) {
        window.console.error('Failed to initialize express payments:', error);
        // Hide loader on error
        $('#express-loader-container').hide();
    });
}

module.exports = {
    renderExpressPaymentContainer: renderExpressPaymentContainer,
    renderPayPalButton: renderPayPalButton,
    renderApplePayButton: renderApplePayButton,
    renderGooglePayButton: renderGooglePayButton,
    renderAmazonPayButton: renderAmazonPayButton,
    init: init
};
